import { wrap } from "svelte-spa-router/wrap";
import Login from "../routes/Login.svelte";
import Dashboard from "../routes/Dashboard.svelte";
import Sites from "../routes/Sites.svelte";
import SiteCreate from "../routes/SiteCreate.svelte";
import SiteDetail from "../routes/SiteDetail.svelte";
import Viewers from "../routes/Viewers.svelte";
import ViewerCreate from "../routes/ViewerCreate.svelte";
import ViewerDetail from "../routes/ViewerDetail.svelte";
import Invites from "../routes/Invites.svelte";
import Access from "../routes/Access.svelte";
import Settings from "../routes/Settings.svelte";
import Storage from "../routes/Storage.svelte";
import Runtime from "../routes/Runtime.svelte";

function guardAuth() {
  const token = localStorage.getItem("snapshot_token");
  if (!token) {
    window.location.hash = "#/login";
    return false;
  }
  return true;
}

function redirectHome() {
  const token = localStorage.getItem("snapshot_token");
  if (token) {
    window.location.hash = "#/dashboard";
  } else {
    window.location.hash = "#/login";
  }
  return false;
}

export const routes = {
  "/": wrap({ component: Login, conditions: [redirectHome] }),
  "/login": Login,
  "/dashboard": wrap({ component: Dashboard, conditions: [guardAuth] }),
  "/sites": wrap({ component: Sites, conditions: [guardAuth] }),
  "/sites/new": wrap({ component: SiteCreate, conditions: [guardAuth] }),
  "/sites/:id": wrap({ component: SiteDetail, conditions: [guardAuth] }),
  "/viewers": wrap({ component: Viewers, conditions: [guardAuth] }),
  "/viewers/new": wrap({ component: ViewerCreate, conditions: [guardAuth] }),
  "/viewers/:id": wrap({ component: ViewerDetail, conditions: [guardAuth] }),
  "/invites": wrap({ component: Invites, conditions: [guardAuth] }),
  "/access": wrap({ component: Access, conditions: [guardAuth] }),
  "/settings": wrap({ component: Settings, conditions: [guardAuth] }),
  "/storage": wrap({ component: Storage, conditions: [guardAuth] }),
  "/runtime": wrap({ component: Runtime, conditions: [guardAuth] }),
  "*": wrap({ component: Login, conditions: [redirectHome] }),
};
